import { render } from "./LootBoxApeInfo.vue?vue&type=template&id=7820cf5c"
import script from "./LootBoxApeInfo.vue?vue&type=script&lang=js"
export * from "./LootBoxApeInfo.vue?vue&type=script&lang=js"

import "./LootBoxApeInfo.vue?vue&type=style&index=0&id=7820cf5c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__